import React from 'react';
import './Styles.css';

function FormErrorMessage({ children }) {
  return (
    <div className="FormErrorMessage">
      {children}
    </div>
  );
}

export default FormErrorMessage;
